import 'simplebar';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { registerLocaleData } from '@angular/common';
import localePL from '@angular/common/locales/pl';
import localeEN from '@angular/common/locales/en';

if (environment.production) {
  enableProdMode();
}

registerLocaleData(localePL);
registerLocaleData(localeEN);

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
